import Swiper from "swiper";

new Swiper(".analyst-reports__slider", {
  slidesPerView: 1,
  spaceBetween: 30,
  autoHeight: true,
  navigation: {
    nextEl: ".analyst-reports__slider-nav-next",
    prevEl: ".analyst-reports__slider-nav-prev",
  },
  breakpoints: {
      500: {
          slidesPerView:2,
          spaceBetween: 30,
      },
      769: {
          slidesPerView: 3,
          spaceBetween: 30,
      },
  }
});
